let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("70lcv")).then(() => parcelRequire('hoETH'));